<template>
  <div
    class="ah-header-navigation"
  >
    <AhOverlay
      v-if="isMobile && isOpen"
      @click="clickOutsideHandler"
    />
    <div
      ref="listMenu"
      class="ah-header-navigation__menu"
      @keydown.tab="accessibilityHandler"
    >
      <AhBurgerMenu
        v-if="showBurgerMenu"
        ref="ahBurgerButton"
        class="ah-header-navigation__burgermenu"
        :is-open="isOpen"
        aria-controls="ah-menu-navigation-selection"
        @burgerMenu:close="closeMenu"
        @burgerMenu:open="openMenu"
      />
      <div
        id="ah-menu-navigation-selection"
        ref="navwrapper"
        class="ah-header-navigation__container"
        :class="{ 'ah-header-navigation__container--panelopened' : isOpen}"
      >
        <div
          ref="navcontainer"
          class="ah-header-navigation__nav"
        >
          <AhItemsNavigation
            v-if="!isNavHidden"
            ref="navlist"
            :key="isOpen"
            :main-items="mainItems"
            :more-items="moreItems"
            :is-mobile="isMobile"
            @nav:panel:clicked="navPanelClickHandler"
            @nav:panel:closed="navPanelClosed"
            @menu:panel:clicked="itemPanelClickHandler"
          />
        </div>
        <div
          v-if="($slots?.geoloc || $slots?.currency) && (geoloc || currency)"
          id="geoloc-selectors"
          class="ah-header-navigation__geoloc"
          @keydown.esc="closeMegaMenu"
        >
          <AhList
            ref="geoloc"
            :column="false"
            marge="large"
          >
            <AhListItem
              v-for="($slot, key) in $slots"
              :key="key"
            >
              <AhMenuItem
                v-if="(geoloc || currency)"
                :aria-controls="key"
                @clicked="clickHandler(key)"
              >
                <template #label>
                  <span 
                    v-if="key === 'geoloc' && geoloc" 
                    :class="'geoloc-placeholder__'+key"
                  >
                    <span>
                      {{ geoloc.lang }}
                    </span>
                    <span>
                      {{ geoloc.language }} <span>({{ geoloc.country }})</span>
                    </span>
                  </span>
                  <span 
                    v-if="key === 'currency' && currency" 
                    :class="'geoloc-placeholder__'+key"
                  >
                    <span :class="'geoloc-placeholder__'+key">
                      {{ currency.currency }} <span>({{ currency.symbole }})</span>
                    </span>
                  </span>
                </template>
              </AhMenuItem>
              <Transition
                v-if="(geoloc || currency)"
                name="ah-fade"
              >
                <AhMegaMenu
                  v-show="(activeItem === key)"
                  :id="key"
                  :ref="'megageoloc_'+key"
                  :aria-label="key"
                  :tabindex="activeItem === key ? 0 : null"
                  @keydown.tab.native="tabKeyHandler"
                  @click:ahbar:back="closeMegaMenu"
                >
                  <template #nav>
                    <slot
                      :name="key"
                    />
                  </template>
                </AhMegaMenu>
              </Transition>
            </AhListItem>
          </AhList>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import AhBurgerMenu from '../../molecules/AhBurgerMenu/AhBurgerMenu.vue';
  import AhList from '../AhList/AhList.vue';
  import AhListItem from '../AhList/_internal/AhListItem.vue';
  import AhMenuItem from '../../molecules/AhMenuItem/AhMenuItem.vue';
  import AhMegaMenu from '../AhMegaMenu/AhMegaMenu.vue';
  import AhItemsNavigation from '../AhItemsNavigation/AhItemsNavigation.vue';
  import AhOverlay from '../../atoms/AhOverlay/AhOverlay.vue';

  export default {
    components: {
      AhMegaMenu,
      AhList,
      AhListItem,
      AhMenuItem,
      AhBurgerMenu,
      AhItemsNavigation,
      AhOverlay,
    },
    inject: {
      fromPre: {
        from: 'prerendering',
        default: false
      }
    },
    props: {
      listItems: {
        type: Array,
        required: true,
      },
      effect: {
        type: String,
        default: 'ah-slide-left',
      },
      mobileBreakpoint: {
        type: [Number, Boolean],
        default: 1023
      },
      isNavHidden: {
        type: Boolean,
        default: false
      },
      geoloc: {
        type: Object,
        default: null,
      },
      currency : {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        windowWidth: null,
        isOpen: false,
        activeItem:null,
        panelData: this.listItems,
        accumItemWidths: [],
      };
    },
    computed: {
      showBurgerMenu() {
        return this.isMobile && (!this.isNavHidden || typeof this.$slots.geoloc !== 'undefined');
      },
      mainItems () {
        return this.panelData.filter((item) => !item.hidden);
      },
      moreItems () {
        return this.panelData.filter((item) => item.hidden);
      },
      isMobile () {
        return this.windowWidth <= this.mobileBreakpoint;
      },
      hasHiddenItems () {
        return !!this.moreItems.length;
      }
    },
    mounted() {
      this.windowWidth = window.innerWidth;
      this.storeItemWidths();
      this.handleResize();
      document.addEventListener('keyup', this.closeMenuOnEsc);
      window.addEventListener('resize', this.handleResize);
      document.addEventListener('click', this.handleClickOutside);
    },
    beforeUpdate () {
      this.handleResize();
    },
    destroyed() {
      document.removeEventListener('keyup', this.closeMenuOnEsc);
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
      handleClickOutside(event) {
        if (!this.$refs?.geoloc?.$el.contains(event.target) && this.activeItem !== null && (this.geoloc || this.currency)) {
          this.closeEmitter();
        }
      },
      clickHandler(key) {
        if(key === this.activeItem) {
          this.closeEmitter();
        } else {
          this.activeItem = key;
          this.$emit('nav:panel:clicked', {
            id: this.activeItem,
            text: (key === 'geoloc' ? this.geoloc.lang : this.currency) ||  null,
            tracking: key === 'geoloc' ? 'select country' : 'select currenct',
            position: this.mainItems.length + 1 + (this.moreItems.length ? 1 : 0) + ((this.geoloc !== null && this.currency !== null) ? (key === 'geoloc' ? 1 : 2) : 1),
            opened: true
          });
          this.$nextTick(() => {
            this.$refs['megageoloc_'+key][0]?.$el?.querySelectorAll('select').length && this.$refs['megageoloc_'+key][0]?.$el?.querySelectorAll('select')[0]?.focus();
          });
        }
      },
      async tabKeyHandler (e) {
        if (e.key && e.key === 'Tab') {
          if (!this.activeItem) return;
          const focusableElements = this.$refs['megageoloc_'+this.activeItem][0]?.$el?.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"], select:not([disabled])') || null;
          if (!focusableElements.length) return;
          if (document.activeElement === focusableElements[focusableElements.length - 1] && !e.shiftKey) {
            this.closeEmitter();
          }
          if (e.shiftKey && document.activeElement) {
            if (
              (document.activeElement.id === 'ah_bar_lang') ||
              (window.innerWidth > 767 && document.activeElement.id === this.activeItem)
            ) {
              this.closeEmitter();
            }
          }
        }
      },
      closeEmitter () {
        this.$emit('nav:panel:closed', {
          id: this.activeItem,
          text: (this.activeItem === 'geoloc' ? this.geoloc.lang : this.currency) ||  null,
          tracking: this.activeItem === 'geoloc' ? 'select country' : 'select currenct',
          position: this.mainItems.length + 1 + (this.moreItems.length ? 1 : 0) + (this.geoloc && this.currency ? (this.activeItem === 'geoloc' ? 1 : 2) : 1),
          opened: false
        });
        this.activeItem = null;
      },
      closeMegaMenu (e) {
        if (!this.activeItem) return;
        this.$nextTick(() =>{
          const elementToReceiveFocus = document.querySelector(`button[aria-controls="${this.activeItem}"]`);
          if (elementToReceiveFocus) {
            elementToReceiveFocus.focus();
          }
          this.closeEmitter();
        });
        if(e) {
          e.preventDefault();
        }
      },
      clickOutsideHandler(){
        if(this.isOpen && this.isMobile) {
          this.isOpen = false;
          this.isOpenPanel = false;
        }
      },
      navPanelClickHandler(data) {
        this.$emit('nav:panel:clicked', {...data});
      },
      itemPanelClickHandler(data) {
        this.$emit('menu:panel:clicked', {...data});
      },
      navPanelClosed(data) {
        this.$emit('nav:panel:closed', data);
      },
      openMenu() {
        this.$emit('burgerMenu:open');
        this.isOpen = true;
        this.$nextTick(() => {
          const focusableElmt = this.getFocusableElements();
          if (focusableElmt && focusableElmt.length) {
            focusableElmt[1].focus();
          }
          document
            .querySelector('body')
            .classList.add('ah-burger-menu-nav--open');
        });
      },
      mobileNavHeight () {
        this.$refs.navwrapper.style.top = `${
          this.$refs.listMenu.offsetHeight + 1
        }px`;
        let offsetTopParents = 0;
        const scrolled = document.querySelector('.scrolled');
        if (this.$refs.navwrapper.offsetParent) {
          offsetTopParents += this.$refs.navwrapper.offsetParent.offsetTop;
        }
        if (this.$refs.navwrapper.offsetParent.offsetParent && !scrolled) {
          offsetTopParents += this.$refs.navwrapper.offsetParent.offsetParent.offsetTop;
        }
        this.$refs.navwrapper.style.height = `${
          window.innerHeight - ( this.$refs.navwrapper.offsetTop + offsetTopParents )}px`;
      },
      closeMenu() {
        this.$emit('burgerMenu:close');
        this.isOpen = false;
        if(this.isMobile) {
          this.$refs.ahBurgerButton.$el.focus();
        }
        document
          .querySelector('body')
          .classList.remove('ah-burger-menu-nav--open');
      },
      closeMenuOnEsc(e) {
        if (this.isOpen) {
          e = e || window.event;
          if (e.key === 'Escape' || e.keyCode === 27) {
            if(!this.isMobile) {
              e.stopPropagation();
              e.preventDefault();
              return;
            }
            this.closeMenu();
            e.preventDefault();
          }
        }
      },
      getFocusableElements() {
        const { listMenu } = this.$refs;
        const focusableElements =
          'a[href], button:not([disabled]), [tabindex="0"], select:not([disabled])';
        const elements = listMenu.querySelectorAll(focusableElements);
        return [...elements].filter((element) => element.offsetParent !== null);
      },
      accessibilityHandler(e) {
        if(this.isMobile && this.isOpen && e?.key === 'Tab') {
          const focusableElms = this.getFocusableElements();
          const activeElt = document.activeElement;
          let element;
          if (e.shiftKey && activeElt === focusableElms[0]) {
            element = focusableElms[focusableElms.length - 1];
          }
          if (
            !e.shiftKey &&
            activeElt === focusableElms[focusableElms.length - 1]
          ) {
            element = focusableElms[0];
          }
          if (element) {
            e.preventDefault();
            element.focus();
          }
        }
      },
      getContainerWidth () {
        let offset = 0;
        if (this.hasHiddenItems) {
          const els = Array.prototype.slice.call(this.$refs.navlist.$el.querySelector('ul').children || []);
          const el = els[els.length - 1];
          els && el && ( offset = this.getWidth(el) );
        }
        return this.$refs.navcontainer.offsetWidth - offset;
      },
      getWidth(el) {
        if (!el) return;
        const margin = 24;
        return Math.ceil(el.querySelector('span').offsetWidth + margin);
      },
      storeItemWidths () {
        if(this.isNavHidden) return;
        let sum = 0;
        if(!this.$refs.navlist) return;
        const els = Array.prototype.slice.call(this.$refs.navlist.$el.querySelector('ul').children || []);
        this.panelData.forEach((item, index) => {
          if (this.$set) {
            this.$set(item, 'width', this.getWidth(els[index]));
          } else {
            item.width = this.getWidth(els[index]);
          }
          sum += item.width;
          if (this.$set) {
            this.$set(this.accumItemWidths, index, sum);
          } else {
            this.accumItemWidths.splice(index, 0, sum);
          }
         
        });
      },
      getLastVisibleItemIndex () {
        let index = 0;
        const containerWidth = this.getContainerWidth();
        while (index < this.accumItemWidths.length) {
          if (this.accumItemWidths[index] > containerWidth) {
            index--;
            break;
          }
          index++;
        }
        return index;
      },
      async handleResize () {
        await this.$nextTick();
        this.windowWidth = window.innerWidth;
        if(this.isMobile) {
          this.mobileNavHeight();
          this.panelData.forEach((item) => {
            if (this.$set) {
              this.$set(item, 'hidden', false);
            } else {
              item.hidden = false;
            }
          });
        } else {
          this.$refs.navwrapper.style.top = 'auto';
          this.$refs.navwrapper.style.height = '100%';
          if(!this.isNavHidden) {
            const lastVisibleItemIndex = this.getLastVisibleItemIndex();
            this.panelData.forEach((item, index) => {
              const hidden = index > lastVisibleItemIndex;
              if (this.$set) {
                this.$set(item, 'hidden', hidden);
              } else {
                item.hidden = hidden;
              }
            });
          }
        }
      }
    },
  };
</script>
